var map = {
	"./IdeaHubRoom/logo-square.svg": "./src/assets/images/logos/IdeaHubRoom/logo-square.svg",
	"./IdeaHubRoom/powered-by-dark.svg": "./src/assets/images/logos/IdeaHubRoom/powered-by-dark.svg",
	"./IdeaHubRoom/powered-by-light.svg": "./src/assets/images/logos/IdeaHubRoom/powered-by-light.svg",
	"./IdeaHubRoom/square.svg": "./src/assets/images/logos/IdeaHubRoom/square.svg",
	"./Mago/powered-by-dark.svg": "./src/assets/images/logos/Mago/powered-by-dark.svg",
	"./Mago/powered-by-light.svg": "./src/assets/images/logos/Mago/powered-by-light.svg",
	"./Mago/square.svg": "./src/assets/images/logos/Mago/square.svg",
	"./Pfur/powered-by-dark.svg": "./src/assets/images/logos/Pfur/powered-by-dark.svg",
	"./Pfur/powered-by-light.svg": "./src/assets/images/logos/Pfur/powered-by-light.svg",
	"./Pfur/square.svg": "./src/assets/images/logos/Pfur/square.svg",
	"./SmartTech/powered-by-dark.svg": "./src/assets/images/logos/SmartTech/powered-by-dark.svg",
	"./SmartTech/powered-by-light.svg": "./src/assets/images/logos/SmartTech/powered-by-light.svg",
	"./SmartTech/square.svg": "./src/assets/images/logos/SmartTech/square.svg",
	"./TAEasyMeeting/powered-by-dark.svg": "./src/assets/images/logos/TAEasyMeeting/powered-by-dark.svg",
	"./TAEasyMeeting/powered-by-light.svg": "./src/assets/images/logos/TAEasyMeeting/powered-by-light.svg",
	"./TAEasyMeeting/square.svg": "./src/assets/images/logos/TAEasyMeeting/square.svg",
	"./Valarea/powered-by-dark.svg": "./src/assets/images/logos/Valarea/powered-by-dark.svg",
	"./Valarea/powered-by-light.svg": "./src/assets/images/logos/Valarea/powered-by-light.svg",
	"./Valarea/square.svg": "./src/assets/images/logos/Valarea/square.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/logos sync recursive ^\\.\\/.*$";